import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4.5 12.5l8 -8a4.94 4.94 0 0 1 7 7l-8 8a4.94 4.94 0 0 1 -7 -7","key":"svg-0"}],["path",{"d":"M8.5 8.5l7 7","key":"svg-1"}]]

/**
 * IconPill
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItcGlsbCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNC41IDEyLjVsOCAtOGE0Ljk0IDQuOTQgMCAwIDEgNyA3bC04IDhhNC45NCA0Ljk0IDAgMCAxIC03IC03IiAvPgogIDxwYXRoIGQ9Ik04LjUgOC41bDcgNyIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/pill
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconPill = createReactComponent('outline', 'pill', 'Pill', __iconNode);

export default IconPill;